export default __webpack_public_path__ + "static/contacts-bg-gradient-0e72579234d1c0a7f689db24b53aa7c9.png";